import SpecCategory, { getSpecCategoryLabel } from "../SpecCategory";

describe("SpecCategory model", () => {
  test("hasMany relations", () => {
    expect(
      SpecCategory.hasMany.map(relation => relation.name)
    ).toMatchSnapshot();
  });

  describe("getSpecCategoryLabel", () => {
    it("returns the name when isActive is true", () => {
      expect(getSpecCategoryLabel({ name: "Category", isActive: true })).toBe(
        "Category"
      );
    });

    it("returns name with (Inactive) suffix when isActive is false", () => {
      expect(getSpecCategoryLabel({ name: "Category", isActive: false })).toBe(
        "Category (Inactive)"
      );
    });

    it("returns empty string when name is undefined", () => {
      expect(getSpecCategoryLabel({ name: undefined, isActive: false })).toBe(
        ""
      );
    });

    it("returns empty string when called with no arguments", () => {
      expect(getSpecCategoryLabel()).toBe("");
    });
  });
});
